import React, { useState } from 'react';
import { bool, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import template from 'url-template';

import { setProfile } from '../../actions/profileActions';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './ProfilesTableRowMenu.module.css';

const ManageUrl = template.parse('/iothub/profiles/manage{?company,profile}');

const ProfilesTableRowMenu = ({
    companyInfo,
    hidden,
    history,
    location,
    onDeleteModal,
    onTrendIntervalChange,
    profile,
    setProfile
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const isDeletable = profile.profileType === 'Custom';

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleManage() {
        const values = new URLSearchParams(location.search);
        setProfile(profile);
        history.push(ManageUrl.expand({
            profile: profile.id,
            company: values.get('company')
        }));
        handleClose();
    }

    function handleToggleDeleteModal() {
        onDeleteModal(profile);
        handleClose();
    }

    function handleTrendChange() {
        onTrendIntervalChange(profile);
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem
                    data-test-id="manage"
                    onClick={handleManage}
                >
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Manage Profile
                </MenuItem>
                {
                    !hidden &&
                    <div>
                        <MenuItem
                            data-test-id="manage"
                            onClick={handleTrendChange}
                        >
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/actionBarItem-trend.svg"
                            />
                            Change Trend Interval
                        </MenuItem>
                        <MenuItem
                            data-test-id="delete"
                            disabled={!isDeletable}
                            onClick={handleToggleDeleteModal}
                        >
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/deleteIconColor.svg"
                            />
                            Delete Profile
                        </MenuItem>
                    </div>
                }
            </Menu>
        </React.Fragment>
    );
};

ProfilesTableRowMenu.defaultProps = {
    hidden:                false,
    onDeleteModal:         () => {},
    onTrendIntervalChange: () => {},
    setProfile:            () => {}
};

ProfilesTableRowMenu.propTypes = {
    profile:               object,
    companyInfo:           object,
    hidden:                bool,
    history:               object,
    location:              object,
    onDeleteModal:         func,
    onTrendIntervalChange: func,
    setProfile:            func
};

const mapDispatchToProps = {
    setProfile
};

export default withRouter(
    connect(null, mapDispatchToProps)(ProfilesTableRowMenu)
);
